import script from "./CustomResourceApplySFSPHZB.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomResourceApplySFSPHZB.vue?vue&type=script&setup=true&lang=ts"

import "./CustomResourceApplySFSPHZB.vue?vue&type=style&index=0&id=71873a71&lang=less&scope=true"

const __exports__ = script;

export default __exports__